// components/common/Select/index.jsx
import React from "react";
import { ChevronDown } from "lucide-react";
import { SelectWrapper, StyledSelect, SelectArrow } from "./styles";

const Select = ({
	options,
	value,
	onChange,
	placeholder = "Select an option",
	disabled = false,
	...props
}) => {
	return (
		<SelectWrapper>
			<StyledSelect
				value={value}
				onChange={onChange}
				disabled={disabled}
				{...props}
			>
				{placeholder && (
					<option value="" disabled>
						{placeholder}
					</option>
				)}
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</StyledSelect>
			<SelectArrow>
				<ChevronDown size={20} />
			</SelectArrow>
		</SelectWrapper>
	);
};

export default Select;
